import RepositoryFactory from "../../admin/apis/index";
const payment = RepositoryFactory.payment;

export default {
  //RAZORPAY
  razorpayCreateOrder({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await payment.razorpayCreateOrder(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  razorpayVerifySignature({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await payment.razorpayVerifySignature(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  //PayU
  getPayULink({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await payment.getPayULink(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  //GATEWAY
  createGateway({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await payment.createGateway(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getGateway({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await payment.getGateway(payload);
        commit("SET_PAYMENT_GATEWAY", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getSingleGateway({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await payment.getSingleGateway(payload);
        commit("SET_SINGLE_PAYMENT_GATEWAY", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  editGateway({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await payment.editGateway(payload);
        // commit("SET_SINGLE_PAYMENT_GATEWAY", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  deleteGateway({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await payment.deleteGateway(payload);
        // commit("SET_SINGLE_PAYMENT_GATEWAY", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  deleteGateway({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await payment.deleteGateway(payload);
        // commit("SET_SINGLE_PAYMENT_GATEWAY", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  sendEmail({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await payment.sendEmail(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
